import * as angular from 'angular';
import {IController} from "angular";

export class DeliveryRoutedIndicationCtrl implements IController {
  routeId: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryRoutedIndication', {
    bindings: {
      routeId: '<'
    },
    template: require('./delivery-routed-indication.html').default,
    controller: DeliveryRoutedIndicationCtrl
  });
